import { render, staticRenderFns } from "./DashboardEmailIcon.vue?vue&type=template&id=1ca7b894&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca7b894",
  null
  
)

export default component.exports